<template>
  <div class="bodyback-light pages">
    <notifications></notifications>
    <Navbar />

    <div class="container pb-0 pt-md-5 pt-sm-5 pt-5">
      <div class="row justify-content-center">
        <div class="col-xl-4 col-lg-7 forms card-alerts">
          <form action="">
            <div class="text-center custom-col mt-4">
              <h1 class="title-view-2 mb-1">Hello</h1>
              <div class="textInHorizontalLine">
                <span>{{ supplierName }}</span>
              </div>
            </div>

            <div class="card pb-3 mt-4 mb-2">
              <div
                class="col-12 text-center"
                v-if="requestStatus !== 'RESOLVED'"
              >
                <i class="f-30 text-danger flaticon-traffic-signal"></i>

                <p class="p-content-card text-center mb-2">
                  You are rejected the quote
                  <span class="strong-lg d-block mt-2"> {{ quoteNumber }}</span>
                </p>
                <p class="p-content-card">
                  To confirm, please select a reason for the rejecting the
                  service
                </p>
                <form role="form" @submit.prevent>
                  <div class="text-left">
                    <b-form-group>
                      <b-form-radio-group
                        id="btn-radios-1"
                        v-model="$v.optionSelected.$model"
                        :options="notes"
                        name="radios-btn-default"
                        value-field="value"
                        text-field="label"
                        tabindex="1"
                        stacked
                        v-bind:class="{
                          'is-invalid': $v.optionSelected.$error
                        }"
                      ></b-form-radio-group>
                    </b-form-group>

                    <small
                      class="invalid-feedback text-center"
                      v-if="$v.optionSelected.$error"
                      >Select a reason</small
                    >
                  </div>

                  <base-alert
                    type="info text-left"
                    class="mb-1 info-min mb-4 p-2"
                    v-if="optionSelected === 'Other'"
                  >
                    <i class="flaticon-circle mr-1"></i>
                    Enter the reason for rejecting the quote
                  </base-alert>

                  <div
                    class="col-xl-12 p-0"
                    v-if="optionSelected === 'Other'"
                    v-bind:class="{ 'is-invalid': $v.reason.$error }"
                  >
                    <label class="title-label">*Other Reason</label>
                    <el-input
                      v-model="$v.reason.$model"
                      placeholder="Other Reason"
                      id="reason"
                      name="reason"
                      maxlength="200"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 5 }"
                      show-word-limit
                    >
                    </el-input>

                    <small
                      class="invalid-feedback text-left"
                      v-if="$v.reason.$error"
                      >Enter a other reason</small
                    >
                  </div>

                  <base-alert
                    type="info text-left"
                    class="mb-1 info-min mb-4 p-2"
                    v-if="optionSelected === 'Wrong Service Rate'"
                  >
                    <i class="flaticon-circle mr-1"></i>
                    Enter updated rate amount
                  </base-alert>

                  <div
                    class="col-xl-12 p-0"
                    v-if="optionSelected === 'Wrong Service Rate'"
                    v-bind:class="{ 'is-invalid': $v.updateRate.$error }"
                  >
                    <label class="title-label">Update Rate</label>
                    <BaseNumberInput
                      v-model.number="$v.updateRate.$model"
                      placeholder="updateRate"
                      id="updateRate"
                      name="updateRate"
                      maxlength="45"
                      markrequired
                    />
                    <small
                      class="invalid-feedback text-left"
                      v-if="$v.updateRate.$error"
                      >Enter a update Rate</small
                    >
                  </div>

                  <base-alert
                    type="info text-left"
                    class="mb-1 info-min mb-4 p-2"
                    v-if="optionSelected === 'No Availability'"
                  >
                    <i class="flaticon-circle mr-1"></i>
                    If you have availability on a different date/time please let
                    us know below, otherwise leave blank
                  </base-alert>

                  <div
                    class="col-xl-12 p-0"
                    v-if="optionSelected === 'No Availability'"
                    v-bind:class="{ 'is-invalid': $v.newAvailability.$error }"
                  >
                    <label class="title-label">Available Date or Time</label>
                    <base-input
                      v-model="$v.newAvailability.$model"
                      placeholder="newAvailability"
                      id="newAvailability"
                      name="newAvailability"
                      maxlength="45"
                      markrequired
                    >
                    </base-input>

                    <small
                      class="invalid-feedback text-left"
                      v-if="$v.newAvailability.$error"
                      >{{
                        !$v.newAvailability.minLength ||
                        $v.newAvailability.$error
                          ? `Minimum ${$v.newAvailability.$params.minLength.min} and Maximun ${$v.newAvailability.$params.maxLength.max} characters.`
                          : ""
                      }}</small
                    >
                  </div>

                  <div class="text-center border-top py-2">
                    <base-button
                      type="primary"
                      class="min-button mb-0"
                      :disabled="loader"
                      @click="rejectQuote()"
                    >
                      <i class="flaticon-send"></i> Send
                    </base-button>
                  </div>
                </form>

                <div class="text-center border-top pt-2">
                  <span class="info-card text-center mb-0 ">
                    For assistance please contact us
                    <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                  </span>
                </div>
              </div>

              <div class="col-12 text-center" v-else>
                <i
                  class="f-30"
                  v-bind:class="[
                    { 'text-success flaticon-check-3': isRejected },
                    { 'text-warning flaticon-traffic-signal': isCancelled },
                    { 'text-danger flaticon-error': isAnError }
                  ]"
                ></i>

                <p class="p-content-card text-center">
                  The quote
                  <span class="strong-lg d-block"> {{ quoteNumber }}</span>
                  <span v-if="isRejected"
                    >has been <strong>Rejected.</strong>
                  </span>
                  <span v-if="isCancelled">
                    has been <strong> Cancelled.</strong>
                  </span>
                  <span v-if="isAnError"
                    >couldn't be rejected. An error occurred while rejecting
                    this reservation. Please try again.</span
                  >
                </p>
                <div class="text-center border-top pt-2">
                  <span class="info-card text-center mb-0 ">
                    For assistance please contact us
                    <a href="mailto:info@rhomtrip.com">info@rhomtrip.com</a>
                  </span>
                </div>
              </div>
            </div>

            <div class="loading mt-3" v-if="loader">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Footer class="footer-pages" />
  </div>
</template>

<script>
import Navbar from "../../Layout/Navbarpages.vue";
import Footer from "../../Layout/ContentFooter.vue";
import endpoint from "../../Commons/Services";

import {
  decimal,
  required,
  minLength,
  maxLength,
  requiredIf,
  minValue
} from "vuelidate/lib/validators";

export default {
  components: {
    Navbar: Navbar,
    Footer: Footer
  },
  data() {
    return {
      optionSelected: "",
      supplierName: "",
      quoteNumber: "",
      notes: [
        { value: "No Availability", label: "No Availability" },
        { value: "Wrong Service Rate", label: "Wrong Service Rate" },
        { value: "Other", label: "Other" }
      ],
      loader: false,
      reason: "",
      updateRate: "",
      newAvailability: "",
      currency: {
        code: "",
        symbol: ""
      },
      requestStatus: "INIT",
      isRejected: false,
      isCancelled: false,
      isAnError: false
    };
  },
  async created() {
    this.quoteId = this.$route.params.id;
    this.supplierName = this.$route.query.supplierName
      ? this.$route.query.supplierName
      : "";
    this.quoteNumber = this.$route.query.quoteNumber
      ? this.$route.query.quoteNumber
      : "";
    this.token = this.$route.query.token ? this.$route.query.token : "";

    await this.getQuoteById(this.quoteId);
  },
  methods: {
    /** Get Quote Details
     * @param {string} quoteId - The ID of the quote to retrieve details for
     */
    async getQuoteById(quoteId) {
      try {
        this.loader = true;
        let { data } = await endpoint.quotes.services.getQuoteDetails(
          quoteId,
          this.token
        );
        this.loader = false;
        if (data) {
          this.quoteNumber = data.booking_number;
          this.supplierName = this.supplierName
            ? this.supplierName
            : data.supplier.businessDetails.name;
          this.currency = {
            code: data.service.currency_code,
            symbol: data.service.currency_symbol
          };
        } else {
          this.quoteNumber = "";
        }
      } catch (error) {
        this.loader = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-error"
        });
      }
    },
    /** Reject Quote
     * Validates the form and sends a request to reject the quote with the selected reason
     */
    async rejectQuote() {
      if (!this.$v.$invalid) {
        const payload = {
          reason: this.getReason(this.optionSelected)
        };
        await this.rejectQuoteById(this.quoteId, payload);
      } else {
        this.$v.$touch();
        this.$notify({
          type: "warning",
          title: "Warning",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    /** Reject Quote by ID
     * @param {string} quoteId - The ID of the quote to reject
     * @param {object} payload - The payload containing the reason for rejection
     */
    async rejectQuoteById(quoteId, payload) {
      try {
        this.loader = true;
        this.requestStatus = "PENDING";
        let { data } = await endpoint.quotes.services.rejectQuote(
          quoteId,
          payload,
          this.token
        );
        this.loader = false;
        this.requestStatus = "RESOLVED";
        if (data) {
          const quote = data;
          if (quote.status === "CANCELLED") {
            this.isCancelled = true;
          } else if (quote.status === "REJECTED") {
            this.isRejected = true;
          } else {
            this.isAnError = true;
          }
        } else {
          this.isAnError = true;
        }
      } catch (error) {
        this.loader = false;
        this.requestStatus = "RESOLVED";
        this.isAnError = true;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The Operation could not be completed. Please try again",
          icon: "flaticon-error"
        });
      }
    },
    getReason(optionSelected) {
      if (optionSelected === "No Availability") {
        return this.newAvailability
          ? `Available on the following date/time: ${this.newAvailability}`
          : "No Availability";
      } else if (optionSelected === "Wrong Service Rate") {
        return `Update Rate: ${this.updateRate} ${this.currency.code}`;
      } else if (optionSelected === "Other") {
        return `${this.reason}`;
      } else {
        return "";
      }
    }
  },
  validations: {
    optionSelected: {
      required
    },
    reason: {
      minLength: minLength(10),
      maxLength: maxLength(200),
      required: requiredIf(function(value) {
        return this.$v.optionSelected.$model === "Other";
      })
    },
    updateRate: {
      decimal,
      minValue: minValue(0.01),
      required: requiredIf(function(value) {
        return this.$v.optionSelected.$model === "Wrong Service Rate";
      })
    },
    newAvailability: {
      minLength: minLength(2),
      maxLength: maxLength(45)
    }
  }
};
</script>
